import React, {useEffect} from 'react';
import {
    BrowserRouter,
    Route,
    Switch,
    RouteChildrenProps,
} from 'react-router-dom';
import {routePublic} from './constants/routes';
import {Provider} from 'react-redux';
import {store} from './app/store';
import './style/global.module.scss';
import styles from './App.module.scss';
import {classNamesFunc} from 'classnames-generics';
import Layout from './layouts';
import {selectMe} from './features/stores/user.slice';
import {useAppSelector} from './app/hooks';
import {checkLogin, fetchConfig, fetchMe, logOut} from './API/login';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import useWindowWidth from '../src/hooks/useWindowWidth';
import {isLocalhost} from './Helper/generalHelper';
import {useTranslation} from 'react-i18next';
import {getPreferredLocale} from './features/util';
import BackDropLoader from './components/BackDropLoader';

const classNames = classNamesFunc();
type Props = {
    active: boolean;
};

const App: React.FunctionComponent<{}> = () => {
    const user: any = selectMe(useAppSelector(store.getState));
    const mobile = useWindowWidth();
    const {t, i18n} = useTranslation();
  
    const changeLanguage = (language: string) => {
      i18n.changeLanguage(language);
    };
    const checkAuthorization = async () => {
        const isAuthorised = await checkLogin();
        /** /mediakit/ pathname check is needed so that public page can be viewed for unautenticated user */
        if (!isAuthorised && !isLocalhost() && window?.location?.pathname?.includes('/mediakit/')) {
            logOut();
        } else if (isAuthorised && !user?.me && user?.loginStatus === 'LOGGED_OUT') {
            fetchMe();
            fetchConfig();
        }
    };
    useEffect(() => {
        checkAuthorization();
    }, []);

    useEffect(()=>{
      changeLanguage(getPreferredLocale());
      if (user?.loginStatus === 'ERROR' && !isLocalhost()) {
        logOut();
      }
    }, [user]);

    useEffect(() => {
        if (/iPad|iPhone|iPod/.test(navigator.userAgent) && document?.querySelector("[name=viewport]")) {
          document?.querySelector("[name=viewport]")!.setAttribute("content", "width=device-width, initial-scale=1, maximum-scale=1");
        }
    }, []);

    return (
            <div className={classNames(styles.appContainer)}>
                <BrowserRouter>
                    <Switch>
                        {routePublic.map((route, index) => {
                            return (
                                <Route
                                    key={index}
                                    path={route.path}
                                    exact={route.exact}
                                    render={(
                                        props: RouteChildrenProps<any>,
                                    ) => (
                                        <route.component
                                            name={route.name}
                                            {...props}
                                            {...route.props}
                                        />
                                    )}
                                />
                            );
                        })};
                        {user?.me ? <Layout /> : <BackDropLoader />}
                    </Switch>
                </BrowserRouter>
                {mobile < 668 ? (
                    <ToastContainer
                        position="top-center"
                        autoClose={1600}
                        style={{padding: `20px`, marginBottom: `220px`}}
                    />
                    ) : (
                    <ToastContainer position="bottom-right" autoClose={6600} />
                )}
            </div>
    );
};

export default App;
